var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiRsFileInvitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-rs-file-invitation"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.8105 0.833496H4.75C4.15326 0.833496 3.58097 1.07494 3.15901 1.50471C2.73705 1.93448 2.5 2.51737 2.5 3.12516V19.1668H17.5V6.62836L11.8105 0.833496ZM12.25 3.44141L14.9395 6.18072H12.25V3.44141ZM4 17.6391V3.12516C4 2.92257 4.07902 2.72827 4.21967 2.58501C4.36032 2.44175 4.55109 2.36127 4.75 2.36127H10.75V7.7085H16V17.6391H4Z",
    fill: "#57689F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2490",
    d: "M8.33337 10H14.1667V11.4167H8.33337V10Z",
    fill: "#57689F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2495",
    d: "M5.83337 6.6665H9.16671V8.08317H5.83337V6.6665Z",
    fill: "#57689F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2493",
    d: "M8.33337 13.3335H14.1667V14.7502H8.33337V13.3335Z",
    fill: "#57689F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2492",
    d: "M5.83337 10H7.50004V11.4167H5.83337V10Z",
    fill: "#57689F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2494",
    d: "M5.83337 13.3335H7.50004V14.7502H5.83337V13.3335Z",
    fill: "#57689F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRsFileInvitation);
export default __webpack_public_path__ + "static/media/fi-rs-file-invitation.a01bb2def1e2594512b7858fc8f43ce9.svg";
export { ForwardRef as ReactComponent };